export default function getResource(label, vars = []) {
    const resources = {
        linkedAccounts: 'Linked Accounts',
        unlink: 'Unlink',
        linkedOn: 'Linked on',
        unlinkAccount: 'Unlink Account',
        cancel: 'Cancel',
        areYouSure: `Are you sure you would like to unlink your Sephora account from ${vars[0]}?`,
        unlinkSuccess: `Your Sephora account has successfully been unlinked from ${vars[0]}.`,
        done: 'Done',
        faq: 'FAQs',
        unlinkError: `We’re sorry. We have encountered an error in unlinking your account. Please try again or contact Sephora via ${vars[0]} or phone at ${vars[1]}.`,
        editButton: 'Edit',
        chat: 'Chat',
        unlinkConfirmation: `<h4>Are you sure you want to unlink your ${vars[0]} x ${vars[1]} account?</h4><ul><li>You won’t be receiving any benefits or promotion of lorem ipsum moving forward</li><li>Relinking in the future would mean you start fresh</li><li>You still won’t be able to redeem the special rewards if you already did this season lorem ipsum</li></ul><p>Find more <a href=\'#\'>${vars[0]} x ${vars[1]} FAQs</a></p><small>By tapping “Unlink Account” you have agreed to Sephora Terms and Privacy Policy and understood that all my stuff won’t be lorem ipsum, and this is the end of the road lorem ipsum.</small>`
    };

    return resources[label];
}
